import React, { cloneElement, CSSProperties, ReactElement } from 'react'
import { IRadioItemProps } from './RadioTabItem'

import './styles.scss'

export interface IProps {
  tabClass?: string
  children: ReactElement[]
  style?: CSSProperties
  onChange: (value: string | number | boolean) => void
}

const BASE_CLASS = 'csas-pills'

const RadioTabs = ({ children, style, tabClass, onChange }: IProps) => {
  const ulClass = tabClass !== undefined ? tabClass : BASE_CLASS

  const tabChildren = children.map((child: ReactElement<IRadioItemProps>, index: number) => {
    return cloneElement(child, { ...child.props, key: index, onChange })
  })

  return (
    <ul role='tablist' className={ulClass} style={style}>
      {tabChildren}
    </ul>
  )
}

export default RadioTabs
